// const {clientFeatureList} = require("./client-feature-list.js");

angular.module('client-feature', ['core'])
    .constant('ClientFeatureConst', {
        eventUpdate: 'client-feature.updated'
    })
    // .component('clientFeatureList', clientFeatureList)
    .config(function ($stateProvider) {
        $stateProvider.state('clientFeatureList', {
            parent: 'app',
            url: '/client-feature?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': 'clientFeatureList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (ClientFeature, $q, $stateParams) => ClientFeature.list(angular.copy($stateParams)).$promise
            }
        })
    })
